import { render } from "./Sidebar.vue?vue&type=template&id=10bc7b51"
const script = {}

import exportComponent from "C:\\Users\\aparl\\Source\\Incodi\\gdm-self-service\\selfservice.dynamicmarkets.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__